//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { genId } from '@/plugins/utils'

export default {
  name: 'CompanyExpiryManagerPage',

  layout: 'page',

  async asyncData({ $axios, query }) {
    const res = await $axios.$get('/company/detail', {
      params: {
        id: query.id,
      },
    })

    if (!res.data) {
      return {}
    }

    const { id, expirationNotice } = res.data

    return {
      id,
      sendFlag: expirationNotice?.sendFlag ?? true,
      charges: (expirationNotice?.charges || []).map(({ name, email }) => ({
        id: genId(),
        name,
        email,
      })),
    }
  },

  data() {
    const { query } = this.$route

    return {
      id: query.id,
      sendFlag: true,
      charges: [],
      formLoading: false,
    }
  },

  computed: {
    allowedSubmit() {
      return (
        this.charges.length <= 5 &&
        this.charges.every((item) => item.name && item.email)
      )
    },
  },

  methods: {
    addCharge() {
      if (this.charges.length >= 5) {
        return
      }

      this.charges.push({
        id: genId(),
        name: '',
        email: '',
      })
    },
    delCharge(index) {
      this.charges.splice(index, 1)
    },
    async save() {
      if (this.formLoading || !this.allowedSubmit) {
        return
      }

      const form = {
        id: this.id,
        expirationNotice: {
          sendFlag: this.sendFlag,
          charges: this.charges.map(({ name, email }) => ({ name, email })),
        },
      }

      this.formLoading = true

      try {
        const res = await this.$axios.post('/company/info', form)

        if (res?.status !== 200) {
          return
        }

        this.$toast({
          message: '保存しました',
        })

        this.$router.push('/company/detail')
      } finally {
        this.formLoading = false
      }
    },
  },
}
